import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const EmbracingAge = lazyWithPreload(() => import('./EmbracingAge'))
